'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _tether = require('tether');

var _tether2 = _interopRequireDefault(_tether);

var _ActiveElement = require('../core/ActiveElement');

var _ComponentWithWindowListeners = require('../mixins/ComponentWithWindowListeners');

var _ComponentWithWindowListeners2 = _interopRequireDefault(_ComponentWithWindowListeners);

var _sizes = require('HubStyleTokens/sizes');

var _PlacementConstants = require('./PlacementConstants');

var _Functions = require('../core/Functions');

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _RootNode = require('../utils/RootNode');

var _Dom = require('../utils/Dom');

var _underscore = require('../utils/underscore');

var _Placement = require('./utils/Placement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBERS_REGEX = /\d+/g;
var DUMMY_ELEMENT = document.createElement('span');

function makeLayerNode(zIndex) {
  var node = document.createElement('div');
  // add z-index for compatibility with other "layered" stuff like vex
  node.style.zIndex = zIndex;
  // position fixed prevents a screen jump when the container mounts
  node.style.position = 'fixed';
  node.style.top = '0px';
  return node;
}

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractPopup',

  mixins: [_reactAddonsPureRenderMixin2.default, _ComponentWithWindowListeners2.default],

  propTypes: {
    addTargetClasses: _react.PropTypes.bool.isRequired,
    autoPlacement: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.oneOf(['horiz', 'vert'])]).isRequired,
    bodyElement: _domElement2.default,
    center: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.element,
    content: _react.PropTypes.node,
    distance: _react.PropTypes.number.isRequired,
    inset: _react.PropTypes.number.isRequired,
    onFocusLeave: _react.PropTypes.func,
    onTetherUpdate: _react.PropTypes.func,
    open: _react.PropTypes.bool.isRequired,
    pinToConstraint: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]).isRequired,
    pinToOutOfBoundsTarget: _react.PropTypes.bool,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    target: _domElement2.default,
    targetAttachment: _react.PropTypes.string.isRequired,
    zIndex: _react.PropTypes.number.isRequired,
    _useMutationObserver: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      addTargetClasses: true,
      autoPlacement: true,
      distance: 0,
      inset: 0,
      pinToConstraint: false,
      targetAttachment: 'auto',
      zIndex: parseInt(_sizes.JUPITER_LAYER, 10),
      _useMutationObserver: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      targetIsOutOfBounds: false,
      targetIsInTransition: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        open = _props.open,
        zIndex = _props.zIndex;

    this._isMounted = true;
    if (open) {
      this.createTether(zIndex);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var target = this.props.target;

    if (target != null && target !== nextProps.target) {
      this.removeTargetEventListeners();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _props2 = this.props,
        open = _props2.open,
        zIndex = _props2.zIndex;

    if (!prevProps.open && open) {
      this.createTether(zIndex);
    } else if (prevProps.open && !open) {
      this.destroyTether();
    } else if (prevProps.open && open) {
      this.updateTether();
      if (prevProps.zIndex !== zIndex) this._element.style.zIndex = zIndex;
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.destroyTether();
    this._isMounted = false;
  },
  getWindowListeners: function getWindowListeners() {
    return {
      keydown: this.handleWindowKeyDown,
      resize: this.handleWindowResize
    };
  },
  getWindowListenersActive: function getWindowListenersActive() {
    var open = this.props.open;

    return open;
  },
  addTargetEventListeners: function addTargetEventListeners() {
    var targetEl = this.getTargetElement();
    if (targetEl != null) {
      targetEl.addEventListener('load', this.updateTetherOptions, true);
    }
  },
  removeTargetEventListeners: function removeTargetEventListeners() {
    var targetEl = this.getTargetElement();
    if (targetEl != null) {
      targetEl.removeEventListener('load', this.updateTetherOptions, true);
    }
  },
  getBodyElement: function getBodyElement() {
    this._rootNode = this._rootNode || this.props.bodyElement || (0, _RootNode.getDefaultNode)();
    return this._rootNode;
  },
  getTetherOptions: function getTetherOptions(contentEl, targetEl, bodyElement) {
    var _props3 = this.props,
        addTargetClasses = _props3.addTargetClasses,
        autoPlacement = _props3.autoPlacement,
        center = _props3.center,
        distance = _props3.distance,
        inset = _props3.inset,
        pinToConstraint = _props3.pinToConstraint,
        pinToOutOfBoundsTarget = _props3.pinToOutOfBoundsTarget,
        placement = _props3.placement,
        targetAttachment = _props3.targetAttachment;
    var _state = this.state,
        targetIsOutOfBounds = _state.targetIsOutOfBounds,
        targetIsInTransition = _state.targetIsInTransition;

    var applyConstraints = !!autoPlacement && !targetIsInTransition;
    var applyPinning = pinToOutOfBoundsTarget || !targetIsOutOfBounds;
    var offset = (0, _Placement.getOffset)(placement, distance, inset);
    var constraints = [];

    // Tether will naïvely try to flip back and forth in an infinite loop if it
    // can't satisfy our constraints, so we need to make sure we have room. Also,
    // there should be no constraints if there is no content.

    var _contentEl$getBoundin = contentEl.getBoundingClientRect(),
        height = _contentEl$getBoundin.height,
        width = _contentEl$getBoundin.width;

    if (applyConstraints && height && width) {
      var _window = window,
          innerHeight = _window.innerHeight,
          innerWidth = _window.innerWidth;

      var _targetEl$getBounding = targetEl.getBoundingClientRect(),
          top = _targetEl$getBounding.top,
          right = _targetEl$getBounding.right,
          bottom = _targetEl$getBounding.bottom,
          left = _targetEl$getBounding.left;

      var horizOffset = Number(offset.match(NUMBERS_REGEX)[1]);
      var vertOffset = Number(offset.match(NUMBERS_REGEX)[0]);
      var totalWidth = width + horizOffset;
      var totalHeight = height + vertOffset;
      var enableHorizConstraint = autoPlacement !== 'vert' && (left - totalWidth > 0 || right + totalWidth < innerWidth);
      var enableVertConstraint = autoPlacement !== 'horiz' && (top - totalHeight > 0 || bottom + totalHeight < innerHeight);
      var horizConstraint = enableHorizConstraint ? 'together' : 'none';
      var vertConstraint = enableVertConstraint ? 'together' : 'none';
      constraints = [{
        to: 'window',
        attachment: vertConstraint + ' ' + horizConstraint,
        pin: applyPinning ? pinToConstraint : false
      }];
    }

    // targetAttachment is computed based on placement and inset (a proxy for
    // whether we have an arrow), but can be overridden.
    var computedTargetAttachment = targetAttachment === 'auto' ? (0, _Placement.getTargetAttachment)(placement, center) : targetAttachment;

    return {
      addTargetClasses: addTargetClasses,
      attachment: (0, _Placement.getAttachment)(placement),
      constraints: constraints,
      element: contentEl,
      bodyElement: bodyElement,
      enabled: true,
      offset: offset,
      target: targetEl,
      targetOffset: (0, _Placement.getTargetOffset)(placement, inset),
      targetAttachment: computedTargetAttachment
    };
  },
  handleWindowFocus: function handleWindowFocus() {
    if (!this._element) {
      return;
    }
    var onFocusLeave = this.props.onFocusLeave;

    var activeEl = (0, _ActiveElement.getActiveElement)();
    if (!this._element.contains(activeEl)) {
      (0, _Functions.callIfPossible)(onFocusLeave);
    }
  },
  handleWindowKeyDown: function handleWindowKeyDown(evt) {
    var key = evt.key;

    if (key === 'Tab') {
      this.handleTab(evt);
    }
  },
  handleTab: function handleTab(evt) {
    // Popups are appended to <body>, which means they live at the end of the document tabbing order,
    // regardless of their visual placement. So when the user presses Tab and it would take them out
    // of the Tether, they should tab to an element adjacent to the popup target.

    var targetEl = this.getTargetElement();
    if (this._element == null || targetEl == null) {
      return;
    }
    var reverseTab = evt.shiftKey;
    var activeEl = (0, _ActiveElement.getActiveElement)();

    var overrideFocusEl = void 0;
    if (this._element.contains(activeEl)) {
      overrideFocusEl = this.getTabTargetFromWithinPopup({
        activeEl: activeEl,
        reverseTab: reverseTab,
        targetEl: targetEl
      });
    } else if (!reverseTab && activeEl === (0, _Dom.getPrevTabbableElementInclusive)(targetEl)) {
      overrideFocusEl = (0, _underscore.first)((0, _Dom.getTabbableElements)(this._element));
    } else if (reverseTab && activeEl === (0, _Dom.getNextTabbableElementExclusive)(targetEl)) {
      overrideFocusEl = (0, _underscore.last)((0, _Dom.getTabbableElements)(this._element));
    }

    if (overrideFocusEl) {
      overrideFocusEl.focus();
      // We prevent the default tab behavior *only* if we succeeded in overriding the focus. This
      // is an escape hatch for any edge cases where overrideFocusEl isn't actually focusable. (The
      // rules of focusability are mercurial and may vary across systems/browsers.)
      if ((0, _ActiveElement.getActiveElement)() === overrideFocusEl) {
        evt.preventDefault();
      }
    }
  },
  getTabTargetFromWithinPopup: function getTabTargetFromWithinPopup(_ref) {
    var activeEl = _ref.activeEl,
        reverseTab = _ref.reverseTab,
        targetEl = _ref.targetEl;

    var tabbableElsWithinPopup = (0, _Dom.getTabbableElements)(this._element);

    if (!reverseTab && activeEl === (0, _underscore.last)(tabbableElsWithinPopup)) {
      // Tab out of the popup to the tabbable element after the target (exclusive).
      return (0, _Dom.getNextTabbableElementExclusive)(targetEl);
    } else if (reverseTab && activeEl === (0, _underscore.first)(tabbableElsWithinPopup)) {
      // Tab out of the popup to the tabbable element before the target (inclusive).
      return (0, _Dom.getPrevTabbableElementInclusive)(targetEl);
    }

    return null;
  },
  handleWindowResize: function handleWindowResize() {
    // We may need to reassess our constraints in light of the new window size.
    this.updateTetherOptions();
  },
  repositionTether: function repositionTether() {
    if (this._tether && this.getBodyElement().contains(this._tether.target)) {
      this._tether.position();
    }
  },
  addImgLoadListeners: function addImgLoadListeners() {
    this._element.addEventListener('load', this.handleImageLoad, true);

    var _element$getBoundingC = this._element.getBoundingClientRect(),
        height = _element$getBoundingC.height,
        width = _element$getBoundingC.width;

    this._prevHeight = height;
    this._prevWidth = width;
  },
  handleImageLoad: function handleImageLoad() {
    // Because loading an image may change the size of the content, we need to
    // reassess our constraints. The update also takes care of repositioning.
    if (!this._element) {
      return;
    }
    this.updateIfContentSizeChanged();
  },
  startMutationObserver: function startMutationObserver() {
    if (this._observer || !this._element) {
      return;
    }
    var _window2 = window,
        MutationObserver = _window2.MutationObserver;

    if (!MutationObserver) {
      return; // No browser support, bummer!
    }
    // The focus should always be inside of the modal. We may need to recapture
    // it after an update because the focused element may have been unmounted.
    this._observer = new MutationObserver(this.updateIfContentSizeChanged);
    this._observer.observe(this._element, {
      attributes: true,
      childList: true,
      subtree: true
    });
  },
  stopMutationObserver: function stopMutationObserver() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  },
  updateIfContentSizeChanged: function updateIfContentSizeChanged() {
    var _useMutationObserver = this.props._useMutationObserver;

    var _element$getBoundingC2 = this._element.getBoundingClientRect(),
        height = _element$getBoundingC2.height,
        width = _element$getBoundingC2.width;

    if (height !== this._prevHeight || width !== this._prevWidth) {
      if (_useMutationObserver) this.stopMutationObserver(); // prevent potential loop
      this.updateTetherOptions();
      if (_useMutationObserver) this.startMutationObserver();
      this._prevWidth = width;
      this._prevHeight = height;
    }
  },
  createTether: function createTether(zIndex) {
    if (this._element) {
      this.destroyTether();
    }
    this._element = makeLayerNode(zIndex);
    this.getBodyElement().appendChild(this._element);
    this.updateTether();
    this.addImgLoadListeners();
    if (this.props._useMutationObserver) {
      this.startMutationObserver();
    }
    this.addTargetEventListeners();
    window.addEventListener('focus', this.handleWindowFocus, true);
    if (_reactDom2.default.createPortal) {
      this.forceUpdate();
    }
  },
  destroyTether: function destroyTether() {
    if (this._tether) {
      this._tether.destroy();
      this._tether = null;
    }
    if (this._element) {
      this._element.parentElement.removeChild(this._element);
      if (!_reactDom2.default.createPortal) {
        _reactDom2.default.unmountComponentAtNode(this._element);
      }
      this._element = null;
    }
    // If focus has been lost, restore focus to the last element
    if (this._lastFocus) {
      var activeEl = (0, _ActiveElement.getActiveElement)();
      if (!activeEl || activeEl === document.body) {
        this._lastFocus.focus();
      }
      this._lastFocus = null;
    }
    this.stopMutationObserver();
    this.removeTargetEventListeners();
    window.removeEventListener('focus', this.handleWindowFocus, true);
  },
  updateTether: function updateTether() {
    if (!this._element) {
      // This can happen because componentDidUpdate can be called after
      // componentWillUnmount. (╯°□°)╯︵ ┻━┻
      return;
    }
    var content = this.props.content;

    if (_reactDom2.default.createPortal) {
      this.updateTetherOptions();
    } else {
      _reactDom2.default.unstable_renderSubtreeIntoContainer(this, content, this._element, this.updateTetherOptions);
    }
  },
  getDummyElement: function getDummyElement() {
    // IE11 throws an error if we try to initialize Tether with an element
    // that isn't in the DOM: HubSpot/UIComponents#1058
    if (!DUMMY_ELEMENT.parentElement) {
      this.getBodyElement().appendChild(DUMMY_ELEMENT);
    }
    return DUMMY_ELEMENT;
  },
  getTargetElement: function getTargetElement() {
    if (!this._isMounted) {
      return null;
    }
    var target = this.props.target;

    return target || (0, _reactDom.findDOMNode)(this);
  },
  updateTetherOptions: function updateTetherOptions() {
    var bodyElement = this.props.bodyElement;

    var contentEl = this._element;
    var targetEl = this.getTargetElement();
    if (!contentEl || !targetEl) {
      return;
    }
    var tetherOptions = this.getTetherOptions(contentEl, targetEl, bodyElement);
    if (!this._tether) {
      this._tether = new _tether2.default(_extends({}, tetherOptions, {
        element: this.getDummyElement()
      }));
      this._tether.on('update', this.handleTetherUpdate);
      this._tether.setOptions(tetherOptions);
    } else {
      this._tether.setOptions(tetherOptions);
    }
  },
  handleTetherUpdate: function handleTetherUpdate(evt) {
    var onTetherUpdate = this.props.onTetherUpdate;

    var targetEl = this.getTargetElement();
    if (!targetEl || !(0, _Dom.elementIsOnScreen)(targetEl)) {
      if (!this.state.targetIsOutOfBounds) this.setState({ targetIsOutOfBounds: true });
      return; // Ignore constraint violations caused by being completely off-screen
    }
    if (this.state.targetIsOutOfBounds) this.setState({ targetIsOutOfBounds: false });
    (0, _Functions.callIfPossible)(onTetherUpdate, evt);
  },
  render: function render() {
    var _props4 = this.props,
        children = _props4.children,
        content = _props4.content,
        open = _props4.open;

    if (_reactDom2.default.createPortal && this._element && open) {
      var Fragment = _react2.default.Fragment || 'span';
      return _react2.default.createElement(
        Fragment,
        null,
        children || null,
        _reactDom2.default.createPortal(content, this._element)
      );
    }
    return children || null;
  }
});
module.exports = exports['default'];